import React from "react";
import { CONTACT } from "../../../container/Constants";

const Links = () => {
  return (
    <div className="links">
      {CONTACT.map((a) => (
        <div key={a.id}>
          <a
            className={a.color}
            href={a.site}
            target="_blank"
            rel="noopener noreferrer"
          >
            {a.name}
          </a>
        </div>
      ))}
    </div>
  );
};

export default Links;
